import { unwrap } from "@scayle/storefront-core/dist/utils/response";
export const rpcCall = (nuxtApp, method, shop) => {
  const fetch = nuxtApp.ssrContext?.event.context.$fetchWithContext ?? $fetch;
  return async (params = void 0) => {
    const data = await fetch(`${shop.apiBasePath ?? "/api"}/rpc/${method}`, {
      // @ts-expect-error Type '"POST"' is not assignable to type 'AvailableRouterMethod<`${string}/rpc/${N}`> | Uppercase<AvailableRouterMethod<`${string}/rpc/${N}`>> | undefined'.ts(2322)
      method: "POST",
      body: {
        payload: params
      },
      headers: {
        "x-shop-id": shop.shopId.toString()
      }
    });
    return await unwrap(data);
  };
};
